import React from "react"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"

import { ProjectInput } from "entities/projects/ui/project-input/ProjectInput"

import { useFloorFormContext } from "../../contexts/FloorFormContext"

export interface FloorProjectInputProps extends WithClassName {
  hideLabel?: boolean
}

export const FloorProjectInput = React.memo(
  ({ className, hideLabel }: FloorProjectInputProps) => {
    const {
      isReadonly,
      isDisabled,
      projectOptions,
      isLoadingProjectOptions,
      hideProject
    } = useFloorFormContext()

    if (hideProject) return null

    return (
      <ProjectInput
        className={classNames("floor-form__project", className)}
        hideLabel={hideLabel}
        items={projectOptions}
        loading={isLoadingProjectOptions}
        readonly={isReadonly}
        disabled={isDisabled}
      />
    )
  }
)
